import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MainViewComponent } from '../main-view/main-view.component';
import { FirstStepComponent } from '../main-view/first-step/first-step.component';
import { SecondStepComponent } from '../main-view/second-step/second-step.component';
import { ThirdStepComponent } from '../main-view/third-step/third-step.component';
import { ContactRadioButtonsComponent } from '../main-view/second-step/contact-radio-buttons/contact-radio-button.component';

import { SchedulerModule } from '@progress/kendo-angular-scheduler';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { IntlModule } from '@progress/kendo-angular-intl';
import { NotificationService } from '@progress/kendo-angular-notification';

import { MainViewService } from './main-view.service';
import { SpinnerService } from '../shared/spinner/spinner.service';
import { SharedService } from '../shared/shared.service';
import { SchedulerNavigationModule } from '../shared/kendo-scheduler-navigation/scheduler-navigation.module';
import { TranslationModule } from '../shared/translation/translation.module';
import { TranslatePipe } from '../shared/translation/translation.pipe';

import { BannerComponent } from './banner/banner.component';
import { ContactComponent } from './banner/contact/contact.component';
import { FirstAndHalfStepComponent } from './first-and-half-step/first-and-half-step.component';

@NgModule({
    imports: [
        BrowserModule,
        RouterModule,
        BrowserAnimationsModule,
        FormsModule,
        SchedulerModule,
        ButtonsModule,
        InputsModule,
        DropDownsModule,
        IntlModule,
        ReactiveFormsModule,
        SchedulerNavigationModule,
        TranslationModule
    ],
    declarations: [
        MainViewComponent,
        FirstStepComponent,
        SecondStepComponent,
        ThirdStepComponent,
        BannerComponent,
        ContactComponent,
        ContactRadioButtonsComponent,
        FirstAndHalfStepComponent
    ],
    providers: [
        MainViewService,
        SpinnerService,
        SharedService,
        NotificationService,
        TranslatePipe
    ],
    bootstrap: [MainViewComponent],
    exports: [
        ContactRadioButtonsComponent
    ]
})
export class MainViewModule { }
